var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const getComparisonDocumentsById = (documentComparisonId, ws) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield new Promise(resolve => {
        ws.send('request:/document-comparison-view:get', { documentComparisonId }, (data) => resolve(data));
    });
    if (response.statusCode !== 200) {
        throw new Error(response.message);
    }
    const comparisonDocuments = response.payload;
    comparisonDocuments.sort((a, b) => a.orderIndex < 0 && b.orderIndex >= 0
        ? 1
        : b.orderIndex < 0 && a.orderIndex >= 0
            ? -1
            : a.orderIndex - b.orderIndex);
    return response.payload;
});
